﻿import {
    ValgStateActionTypes,
    ValgState,
    UPDATE_VALG,
    TOGGLE_VILKAR,
    ToggleVilkarAction,
    TOGGLE_MODAL,
    ToggleModalAction
} from './Types';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederLutAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';
import VerdensdelValg from '../../Utilities/A-VerdensdelValg';
import { VerdensdelViewModel, LandViewModel, LarestedViewModel } from '../../Utilities/LutApi';


export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleVilkar(): ToggleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

export function toggleModal(): ToggleModalAction {
    return {
        type: TOGGLE_MODAL,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederLutAppState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<VeilederLutAppState, {}, AnyAction>, getState: () => VeilederLutAppState): void => {
        const currentState = getState();

        const visBoksB = visB(currentState);
        const visBoksC = visC(currentState);
        const visBoksD = visD(currentState);

        const visResultatA = visResA(currentState);
        const visResultatB = visResB(currentState);
        const visEkstraboks = visEkstr(currentState);

        dispatch(setVisning({ visBoksB, visBoksC, visBoksD, visResultatA, visResultatB, visEkstraboks }));
    };
};

const visB = (state: VeilederLutAppState): boolean => {
    if (state.valg.aVerdensdel !== null
        && (state.valg.aVerdensdel!.value === VerdensdelValg.a1_afrika 
            || state.valg.aVerdensdel!.value === VerdensdelValg.a2_asia
            || state.valg.aVerdensdel!.value === VerdensdelValg.a3_europa
            || state.valg.aVerdensdel!.value === VerdensdelValg.a4_nordMellomAmerika
            || state.valg.aVerdensdel!.value === VerdensdelValg.a5_oseania
            || state.valg.aVerdensdel!.value === VerdensdelValg.a6_sorAmerika))
        return true;

    return false;
};

const visC = (state: VeilederLutAppState): boolean => {

    // sett blankt lærested dersom valgt land ikke er parent til valgt lærested - forutsatt at "Nei" ikke er satt
    if (state.valg.cLarested !== undefined) {
        if (LarestedTilhorerLand(state.lutData!.Verdensdeler, state.valg.cLarested.id, state.valg.bLand!.id, state.valg.aVerdensdel!.id)) {
            return true;
        } else {
            if (LandHarLaresteder(state.lutData!.Verdensdeler, state.valg.bLand!.id)) {
                if (state.valg.cLarested.id == "Nei") {
                    return true;
                }
                state.valg.cLarested = undefined;
                return true;
            } else {
                state.valg.cLarested = undefined;
                return false;
            }
        }
    }

    // om c ikke er satt, sjekk om b har læresteder - skjul c-boks dersom vi ikke har noen
    if (state.valg.bLand !== undefined) {
        if (LandHarLaresteder(state.lutData!.Verdensdeler, state.valg.bLand.id)) {
            return true;
        }
    }

    return false;
};

const visD = (state: VeilederLutAppState): boolean => {
    if (state.valg.cLarested !== undefined && state.valg.cLarested.value !== "Nei" ) return true;
    return false;
};

const visResA = (state: VeilederLutAppState): boolean => {
    if (state.valg.cLarested?.value !== "Nei" && state.valg.dHelsefag !== undefined) return true;
    return false;
}

const visResB = (state: VeilederLutAppState): boolean => {   
    if (state.valg.cLarested !== undefined && state.valg.cLarested.value === "Nei") {
        return true;
    }

    if (state.valg.cLarested === undefined && state.valg.bLand && !LandHarLaresteder(state.lutData!.Verdensdeler, state.valg.bLand?.id)) {
        return true;
    }

    return false;
}

const visEkstr = (state: VeilederLutAppState): boolean => {
    if (visResA(state) && state.valg.eEkstraboks) return true;
    return false;
}

const LandHarLaresteder = (verdensdeler: VerdensdelViewModel[], landkode: string): boolean => {
    for (let i = 0; i < verdensdeler.length; i++) {
        let landListe: LandViewModel[] = verdensdeler[i].LandListe;
        for (let j = 0; j < landListe.length; j++) {
            let land = landListe[j];
            if (land.LandKode === landkode) {
                if (land.Laresteder!.length > 0) {
                    return true;
                }
            }
        }
    }

    return false;
}

const LarestedTilhorerLand = (verdensdeler: VerdensdelViewModel[], larestedId: string, valgtlandkode: string, valgtverdensdelkode: string): boolean => {
    for (let i = 0; i < verdensdeler.length; i++) {
        if (verdensdeler[i].VerdensdelKode === valgtverdensdelkode) {
            let landListe: LandViewModel[] = verdensdeler[i].LandListe;
            for (let j = 0; j < landListe.length; j++) {
                let land = landListe[j];
                if (land.LandKode === valgtlandkode && land.Laresteder !== undefined) {
                    let larestedser: LarestedViewModel[] = land.Laresteder;
                    if (larestedser?.length > 0) {
                        for (let k = 0; k < larestedser.length; k++) {
                            let la = larestedser[k];
                            if (la.LarestedId.toString() == larestedId) {
                                return true;
                            }
                        }
                    }
                }
            }
        }
    }

    return false;
}
